/**
 * Copyright (C) SiteVision AB 2002-2025, all rights reserved
 */
import sv from '@sv/core';

const portlets = document.querySelectorAll(
  `div[id^="svid12"][class*="sv-portlet"],
  div[id^="svid12"][class*="sv-text-portlet"],
  .sv-error`
);

const knownSubSelectors = {
  'sv-text-portlet': ['.sv-tablesorter', '.sv-responsiveTable'],
  'sv-archive-portlet': ['.sv-like'],
  'sv-blog-portlet': ['.sv-like'],
  'sv-contentlist-portlet': ['.sv-carousel', '.env-tabs'],
  'sv-tagcloud2-portlet': ['.sv-defaultlist'],
};

const portletSet = {};
const portletSelectorPattern = /^sv-.*-portlet$/;
const hasOwn = Object.prototype.hasOwnProperty;

for (let i = 0; i < portlets.length; i++) {
  const portletDiv = portlets[i];
  const classList = portletDiv.classList;

  for (let j = 0; j < classList.length; j++) {
    const portletSelector = classList[j];

    if (!portletSelectorPattern.test(portletSelector)) {
      continue;
    }

    const portlet = portletSet[portletSelector] || {};
    const subPortletSelectors = knownSubSelectors[portletSelector];

    if (subPortletSelectors) {
      const data = portlet.data || {};

      for (let k = 0; k < subPortletSelectors.length; k++) {
        const subSelector = subPortletSelectors[k];

        if (portletDiv.querySelector(subSelector)) {
          data[subSelector] = true;
        }
      }

      portlet.data = data;
    }

    portletSet[portletSelector] = portlet;
  }
}
sv.foundPortlets = portletSet;

export const hasPortlet = (portletSelector) => {
  return hasOwn.call(sv.foundPortlets, portletSelector);
};

export const hasSubPortlet = (portletSelector, subPortletSelector) => {
  const portlet = sv.foundPortlets[portletSelector];
  if (!portlet) {
    return;
  }
  return !!(portlet.data && portlet.data[subPortletSelector]);
};
